export default class Report {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async create(name, definition) {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        formData.append('name', name);
        formData.append('definition', JSON.stringify(definition));
        return this.api.post_with_token('/reports', formData);
    }

    async list() {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/reports/list', formData);
    }

    async refresh(reportId) {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        formData.append('report_id', String(reportId));
        return this.api.post_with_token('/reports/refresh', formData);
    }

    async update(reportId, name, definition) {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        formData.append('report_id', String(reportId));
        if (name != null) {
            formData.append('name', name);
        }
        if (definition != null) {
            formData.append('definition', JSON.stringify(definition));
        }
        return this.api.post_with_token('/reports/update', formData);
    }

    async delete(reportId) {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        formData.append('report_id', String(reportId));
        return this.api.post_with_token('/reports/delete', formData);
    }
}
